export default "__VITE_ASSET__Bjk1otW2__"